import { Navigation, Pagination, Lazy, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

export default {
  name: 'instagram',
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const onSwiper = (swiper) => {
      //console.log(swiper);
    };
    return {
      onSwiper,
      modules: [Navigation, Pagination, A11y],
    };
  },
  data() {
    return {
      loading: true,
      posts: [],
    };
  },

  methods: {
    getPosts() {
      axios
        .get(`https://production-access-api.cotopaxi.com/instagram/getFeed`)
        .then((res) => {
          this.posts = res.data;
          this.loading = false;
        })
        .catch((err) => {
          this.error = true;
        });
    },
  },
  mounted() {
    this.getPosts();
  },
};
